<template>
  <div class="row">
    <div class="col-sm-12 col-md-12">
      <div class="row m-t-20">
        <div class="col-lg-12">
          <h4 class="card-title">
            {{ principle.principle_index }}. {{ principle.description }}
          </h4>
          <h4 v-if="principle.objective" class="card-subtitle">
            {{ principle.objective }}
          </h4>
        </div>
      </div>
      <div class="row m-t-10">
        <template v-for="criterion in principle.criteria">
          <criteria :key="criterion" :principle-index="principle.principle_index" :criteria="criterion" />
        </template>

        <template v-if="!principle.criteria && principle.control_points.length>0">
          <div class="col-sm-12 col-md-12 card-head">
            <table class="table table-bordered">
              <thead class="card-print">
                <tr>
                  <th>Id</th>
                  <th>Obligation</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="indicator in principle.control_points">
                  <tr :key="indicator.control_point_id" class="m-t-10 card-print">
                    <td class="text-left">
                      {{ indicator.control_point_name }}
                    </td>
                    <td class="text-left">
                      <span v-if="indicator.obligation === 'Major'">Major Must</span>
                      <span v-if="indicator.obligation === 'Minor'">Minor Must</span>
                    </td>
                    <td class="text-left">
                      {{ indicator["description"] }}
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Criteria from './Criteria.vue';

export default {
  name: 'Principle',
  components: { Criteria },
  props: ['principle'],
  methods: {
    getPityName(name) {
      return name.substring(name.indexOf(' '));
    }
  }
}
</script>

<style scoped>
</style>
